import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(['WebformElementTel'], () => {
  return {
    $formkit: 'tel',
  }
})
